export default __webpack_public_path__ + "static/media/word.3520590c.png";